import { ApiClient } from "./clients";
import { Collection } from "./models/common/Collection";
import { DetailedProject } from "./models/project/DetailedProject";
import { PrimaryMarketProject } from "./models/project/PrimaryMarketProject";
import { OwnedProject } from "./models/project/OwnedProject";
import { buildQuery } from "./utils";
import { ProjectStatus } from "@/utils/api-client/enums";
import { InterestRateType } from "@/utils/api-client/enums/InterestRateType";

export type ListFilter = {
  name?: string;
  interestRateType?: InterestRateType | null;
  projectStatuses?: ProjectStatus[];
  noProxy?: boolean | null;
  interestRateFrom?: number | null;
  interestRateTo?: number | null;
  initialTermFrom?: number | null;
  initialTermTo?: number | null;
  loanAmountFrom?: number | null;
  loanAmountTo?: number | null;
};

export class ProjectProvider {
  constructor(private readonly apiClient: ApiClient) {}

  getListOwned(page = 1, perPage = 25): Promise<Collection<OwnedProject>> {
    return this.apiClient.get(`/owned?page=${page}&perPage=${perPage}`);
  }

  getListFundRaising(
    filter: ListFilter,
    page = 1,
    perPage = 25
  ): Promise<Collection<PrimaryMarketProject>> {
    return this.apiClient.get(
      `/fund-raising-project?${buildQuery(
        filter,
        "filter"
      )}&page=${page}&perPage=${perPage}`
    );
  }

  getListFundRaisingLoan(
    filter: ListFilter,
    page = 1,
    perPage = 25
  ): Promise<Collection<PrimaryMarketProject>> {
    return this.apiClient.get(
      `/fund-raising-loan?${buildQuery(
        filter,
        "filter"
      )}&page=${page}&perPage=${perPage}`
    );
  }

  getOne(uuid: string): Promise<DetailedProject> {
    return this.apiClient.get(`/${uuid}`);
  }
}
